<template>
  <div>
    <div class="vx-row mb-6" id="report-cards" v-if="showPortlet">
      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #ff9f43, #fdc38c)"
        >
          <div
            class="
              flex
              justify-between
              flex-row-reverse
              items-center
              yellow-card
            "
          >
            <span
              class="
                p-3
                inline-flex
                rounded-full
                feather-icon
                select-none
                relative
                text-warning
              "
            >
              <feather-icon icon="ClipboardIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("TotalOrders") }}</h6>
              <h5>{{ chartHeader.totalBaskets }}</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #639, #aa75de)"
        >
          <div
            class="
              flex
              justify-between
              flex-row-reverse
              items-center
              purple-card
            "
          >
            <span
              class="
                p-3
                inline-flex
                rounded-full
                feather-icon
                select-none
                relative
              "
            >
              <feather-icon icon="FileIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("FinalDraftOrders") }}</h6>
              <h5>{{ chartHeader.totalConfirmedDraftOrders }}</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #17bbea, #8be0f9)"
        >
          <div
            class="flex justify-between flex-row-reverse items-center blue-card"
          >
            <span
              class="
                p-3
                inline-flex
                rounded-full
                feather-icon
                select-none
                relative
              "
            >
              <feather-icon icon="FileTextIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("FinalOrders") }}</h6>
              <h5>{{ chartHeader.totalConfirmedOrders }}</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #28c76f, #58d891)"
        >
          <div
            class="
              flex
              justify-between
              flex-row-reverse
              items-center
              green-card
            "
          >
            <span
              class="
                p-3
                inline-flex
                rounded-full
                feather-icon
                select-none
                relative
              "
            >
              <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("TotalOrdersAmount") }}</h6>
              <h5>
                {{ Number(chartHeader.totalOrdersAmount).toLocaleString() }}
                ریال
              </h5>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="نمودار فروش" class="mb-6">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>
              <date-picker
                v-model="filter.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                @input="changeDate"
                :clearable="true"
              />
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>
              <date-picker
                v-model="filter.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                @input="changeDate"
                :clearable="true"
              />
            </div>
            <div class="vx-col w-full sm:w-1/34 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <label class="vs-select--label">{{ $t("Type") }}</label>
              <v-select
                label="name"
                name="pageType"
                :options="chartTypes"
                v-model="chartType"
                :reduce="x => x.id"
                @input="selectType"
                class="mt-1"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
          <div v-if="showChart">
            <chartjs-component-line-chart
              :height="150"
              :data="data"
              :options="options"
            ></chartjs-component-line-chart>
          </div>
          <div v-if="!showChart" style="height: 328px"></div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import ChartjsComponentLineChart from "@/views/charts-and-maps/charts/chartjs/charts-components/ChartjsComponentLineChart.vue";
import { mapGetters, mapActions } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import "@/assets/scss/vuesax-rtl/pages/_reports.scss";
import vSelect from "vue-select";
import utils from "@/assets/utils/index";

const dynamicColors = function() {
  var r = Math.floor(Math.random() * 220);
  var g = Math.floor(Math.random() * 220);
  var b = Math.floor(Math.random() * 220);
  return "rgb(" + r + "," + g + "," + b + ")";
};
export default {
  name: "saleManagement_Reports_Contract_BasicInfo_Index",
  props: {
    contractId: {
      default: {}
    }
  },
  computed: {
    ...mapGetters({
      chartHeader: "reports/chartHeader",
      chartData: "reports/chartData"
    })
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      data: {
        labels: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31
        ],
        datasets: null
      },
      options: {
        title: {
          display: true
        },
        responsive: true,
        legend: {
          position: "bottom",
          align: "center",
          labels: {
            fontFamily: "IRANSans",
            fontSize: 14,
            padding: 20
          }
        },
        tooltips: {
          mode: "label",
          label: "mylabel",
          callbacks: {
            label: function(tooltipItem, data) {
              var tooltipValue =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return (
                data.datasets[tooltipItem.datasetIndex].label +
                " : " +
                parseInt(tooltipValue).toLocaleString()
              );
            }
          },
          titleFontFamily: "IRANSans",
          bodyFontFamily: "IRANSans",
          bodyFontSize: 14,
          titleFontSize: 14,
          titleAlign: "right",
          bodyAlign: "right",
          bodySpacing: 5,
          yPadding: 10,
          xPadding: 10
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback: function(value) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(",");
                  return value;
                },
                fontFamily: "IRANSans",
                fontSize: 13
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontFamily: "IRANSans",
                fontSize: 13
              }
            }
          ]
        }
      },
      chartTypes: [{ name: "ریالی", id: 1 }, { name: "تعدادی", id: 2 }],
      chartType: 1,
      showChart: false,
      showPortlet: false,
      filter: {
        FromDate: "",
        ToDate: ""
      }
    };
  },
  methods: {
    ...mapActions({
      fetchChartHeader: "reports/fetchChartHeader",
      fetchChartData: "reports/fetchChartData"
    }),

    load() {
      var model1 = "";
      if (this.contractId) {
        model1 = "contractId=" + this.contractId;
      } else {
        model1 = "";
      }
      this.fetchChartHeader({ model1, params: "" });
      this.loadChart(this.contractId, false, "");
      this.showPortlet = true;
    },
    selectType(type) {
      this.showChart = false;
      var params = utils.toQueryString(this.filter);
      if (type === 1) {
        this.loadChart(this.contractId, false, params);
      }
      if (type === 2) {
        this.loadChart(this.contractId, true, params);
      }
    },
    loadChart(contractId, isByCount, params) {
      var model = "";
      if (contractId) {
        model = "contractId=" + contractId;
      } else {
        model = "";
      }
      this.fetchChartData({
        model,
        isByCount: isByCount,
        params: params
      }).then(() => {
        //Set DataSets Value
        this.data.datasets = this.chartData.map(function(row) {
          var amounts = [];
          for (let value of Object.values(row.amountsPerDay)) {
            amounts.push(value);
          }
          return {
            data: amounts,
            label: row.month,
            borderColor: dynamicColors(),
            fill: false
          };
        });
        this.showChart = true;
      });
    },
    changeDate() {
      this.showPortlet = false;
      this.showChart = false;
      var params = utils.toQueryString(this.filter);
      this.fetchChartHeader({ id: this.contractId, params: params }).then(
        () => {
          this.showPortlet = true;
        }
      );
      if (this.chartType == 1) {
        this.loadChart(this.contractId, false, params);
      }
      if (this.chartType == 2) {
        this.loadChart(this.contractId, false, params);
      }
    }
  },
  components: {
    ChartjsComponentLineChart,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker
  }
};
</script>
